import { Table } from '@mui/material';
import { TableComponents } from 'react-virtuoso';

import { TanStackTableContext } from './type';

export const DefaultTable: TableComponents<unknown, TanStackTableContext<any>>['Table'] = ({ style, ...props }) => {
    return (
        <Table
            {...props}
            style={{
                ...style,
                width: '100%',
                tableLayout: 'fixed',
                borderCollapse: 'separate',
                borderSpacing: 0,
            }}
        />
    );
};
